import React, { FC, KeyboardEvent, useCallback, useEffect, useRef, useState } from 'react'
import { useLoadedData } from '../../../hooks/useGetLoadedData'
import { ShortLinkFilterParam } from '../../../../services/cellcast.v2.types'
import {
  useLazyAnalyticShortLinkCountByCityQuery,
  useLazyAnalyticShortLinkCountByCountryQuery,
  useLazyAnalyticShortLinkReportExportQuery,
  useLazyAnalyticShortLinkReportQuery,
  useLazyGetShortLinkDetailExportQuery,
  useLazyGetShortLinksExportQuery,
  useLazyGetShortLinksQuery,
} from '../../../../services/cellcast.v2'
import { toast } from 'react-toastify'
import {
  Button,
  ButtonGroup,
  Col,
  OverlayTrigger,
  Row,
  Spinner,
  ToggleButton,
  Tooltip,
} from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../Components/NodataYet'
import { KTSVG } from '../../../../_metronic/helpers'
import DatePicker from 'react-datepicker'
import GeoMaps from '../../../Components/GeoMaps'
import { MapData } from '@unovis/ts'
import moment from 'moment'
import { useTimezone } from '../../../hooks/useTimezone'
import { Link, useLocation } from 'react-router-dom'
import ShortUrlModal from '../MyTemplate/CreateScratch/ShortUrlModal'
import { InputMessageContentRef } from '../../../Components/types/InputMessageContent'
import { ENV } from '../../../Utils/_helpers/EnvHelper'

const ShortLinkPage: FC = () => {
  return (
    <>
      <AnalyticCountGroup />
      <AllShortLinksTable />
      <ShortLinkAnalytic />
    </>
  )
}

const ShortLinkAnalytic: FC = () => {
  const ref = useRef<HTMLDivElement | null>(null)
  const location = useLocation()

  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const { calculate, loadedData, setLoadedData } = useLoadedData()
  const [params, setParams] = useState<ShortLinkFilterParam>({
    page: 1,
    limit: 10,
  })

  const [triggerFetch, setTriggerFetch] = useState(false)

  const [fetch, { isLoading, data, isFetching }] = useLazyAnalyticShortLinkReportQuery()

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([null, null])
  const [startDate, endDate] = dateRange

  const [getApiExport, {isLoading: isLoadingExport}] = useLazyAnalyticShortLinkReportExportQuery()

  const donwloadData = () => {
    getApiExport(params)
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  useEffect(() => {
    fetch(params)
  }, [])

  useEffect(() => {
    if (triggerFetch && triggerFetch === true) {
      doFetch(params)
    }
    setTriggerFetch(false)
  }, [triggerFetch])

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search)
    const scrollId = queryParams.get('scrollId')
    if (scrollId && scrollId === 'activity-log' && ref.current != null) {
      const timeout = setTimeout(() => {
        if (ref.current) {
          ref.current.scrollIntoView({behavior: 'smooth'})
        }
      }, 500)
      return () => clearTimeout(timeout)
    }
  }, [location.search, isLoading])

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams

    if (endDate === null) {
      endDate = new Date()
    }

    setParams({
      ...params,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })

    setTriggerFetch(true)
    setDateRange(dateRangeParams)
  }

  const doFetch = useCallback(
    (params) => {
      fetch(params)
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error Fetch Message:', res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [fetch]
  )

  return (
    <div className='mt-8' ref={ref}>
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-5' style={{ zIndex: 20 }}>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <div>
                <span className='fw-bolder fs-3 mb-1'>Activity Log</span>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id="tooltip-bottom">
                    <div>
                      <span>Tracks clicks and links them to campaigns, helping identify recipient responses for better personalization and segmentation.</span>
                    </div>
                  </Tooltip>}
                >
                  <i
                    className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
                  />
                </OverlayTrigger>
              </div>
            </h3>
            <div className='d-flex gap-4 align-items-center justify-content-between mt-5  flex-column flex-sm-row overflow-hidden'>
              <div className='d-flex flex-column flex-sm-row'>
                <div className='d-flex border-1 h-46px'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-1 position-absolute ms-6 mt-3'
                  />
                  <input
                    type='text'
                    value={params.code ? params.code : ''}
                    data-kt-user-table-filter='search'
                    className='rounded-start form-control form-control-solid max-w-300px ps-14'
                    style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, height: '46px' }}
                    placeholder='Search Link'
                    onChange={(e: any) => setParams({ ...params, code: e.target.value, page: 1 })}
                    onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
                      if (event.key === 'Enter') {
                        event.preventDefault()
                        setTriggerFetch(true)
                      }
                    }}
                  />
                </div>
                <button
                  className='rounded-end btn btn-light-primary mt-4 mt-sm-0 ms-0 me-3'
                  style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  onClick={() => setTriggerFetch(true)}
                >
                  Search
                </button>
              </div>
              <div className='d-flex gap-4 flex-column flex-sm-row'>
                <div
                  className='d-flex border-1 h-46px'
                  style={{ maxWidth: '167px', borderRadius: '8px', border: '1px solid #DFE0E1' }}
                >
                  <input
                    type='text'
                    value={params.click && params.click > 0 ? params.click : ''}
                    data-kt-user-table-filter='search'
                    className='rounded-end form-control form-control-transparent'
                    placeholder='Total Click'
                    onChange={(e: any) =>
                      setParams({ ...params, click: parseInt(e.target.value) || 0, page: 1 })
                    }
                    onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
                      if (event.key === 'Enter') {
                        event.preventDefault()
                        setTriggerFetch(true)
                      }
                    }}
                  />
                  <span
                    className='input-group-text bg-transparent border-0'
                    style={{ backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa' }}
                  >
                    <KTSVG path='/media/svg/filter.svg' className='svg-icon-1' />
                  </span>
                </div>
                <div
                  className='d-flex'
                  style={{ maxWidth: '300px', borderRadius: '8px', border: '1px solid #DFE0E1' }}
                >
                  <DatePicker
                    selectsRange={true}
                    dateFormat='dd-MM-yyyy'
                    className='border-0 form-control form-control-lg form-control-transparent'
                    placeholderText='Date Range'
                    onChange={(update) => {
                      setDateParams(update)
                    }}
                    startDate={startDate}
                    endDate={endDate}
                    disabled={isLoading}
                  />
                  <span
                    className='input-group-text bg-transparent border-0'
                    style={{ backgroundColor: '#f5f8fa', borderRadius: 0, borderColor: '#f5f8fa' }}
                  >
                    <KTSVG path='/media/svg/calendar.svg' className='svg-icon-1' />
                  </span>
                </div>
                <button type='button' onClick={donwloadData} className='btn btn-light-primary'>
                  {isLoadingExport ? (
                    <Spinner size='sm' />
                  ) : (
                    <>
                      <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                      Export
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data.items && data.data.items.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle sticky-header gs-0 gy-5 all-message-table table-row-gray-300'>
                    <thead>
                      <tr className='fw-600 text-muted fs-5'>
                        <th className='min-w-150px min-h-64px ps-2'>Short Link</th>
                        <th className='min-w-100px min-h-100px'>Destination Link</th>
                        <th className='min-w-140px min-h-64px'>Recipient Number</th>
                        <th className='min-w-100px min-h-64px'>Bulk</th>
                        <th className='min-w-100px min-h-64px text-center'>Click</th>
                        {/* <th className='min-w-100px min-h-64px text-center'>Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={5} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((item, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-1 border-bottom'>
                                <td className='top-align text-truncate'>{item.fullUrl || '--'}</td>
                                <td className='top-align text-truncate text-wrap'>{item.shorturl || '--'}</td>
                                <td className='top-align text-truncate'>{item.number || '--'}</td>
                                <td className='top-align text-truncate'>
                                  {item.bulkData?.name || '--'}
                                </td>
                                <td className='top-align text-truncate text-center'>{item.click}</td>
                                {/* <td className='text-center'>
                                  <button
                                    onClick={() => { }}
                                    type='button'
                                    className='btn btn-sm btn-icon btn-light-primary ms-3 mb-5'
                                  >
                                    <KTSVG
                                      path='/media/icons/duotune/general/gen052.svg'
                                      className='svg-icon-2'
                                    />
                                  </button>
                                </td> */}
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <div className='d-flex gap-sm-1 align-items-center text-muted'>
                    <div>Show data</div>
                    <select
                      onChange={(e: any) => {
                        setParams({ ...params, limit: e.target.value })
                        setTriggerFetch(true)
                      }}
                      value={params.limit || 10}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                    <div>per page</div>
                  </div>
                  {isFetching
                    ? '. . . . .'
                    : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${data.data.total ? data.data.total : 0
                    } Usage`}
                  <ReactPaginate
                    previousLabel='< Prev'
                    nextLabel='Next >'
                    previousClassName={'pagination_prev_next'}
                    nextClassName={'pagination_prev_next'}
                    pageCount={data?.data?.totalPages}
                    marginPagesDisplayed={0}
                    onPageChange={(e: any) => {
                      setParams({ ...params, page: e.selected + 1 })
                      setTriggerFetch(true)
                    }}
                    breakLabel='...'
                    pageRangeDisplayed={3}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet message='No Activity Log (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

const AllShortLinksTable: FC = () => {
  const { getUserTimezoneNow } = useTimezone()
  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const userTimezoneNow = getUserTimezoneNow()
  const { calculate, loadedData, setLoadedData } = useLoadedData()
  const [params, setParams] = useState<ShortLinkFilterParam>({
    page: 1,
    limit: 10,
  })
  const [exportedId, setExportedId] = useState('')

  const [triggerFetch, setTriggerFetch] = useState(false)

  const [fetch, { isLoading, data, isFetching }] = useLazyGetShortLinksQuery()
  const [fetchExport, { isLoading: isLoadingExport, data: dataExport, isFetching: isFetchingExport }] = useLazyGetShortLinkDetailExportQuery()

  const inputRef = useRef<InputMessageContentRef | null>(null) // Updated ref type
  const [popup, setPopup] = useState(false)
  const [webLinkDataToEdit, setWebLinkDataToEdit] = useState({ longUrl: '', shortUrl: '' })

  const [getApiExport, {isLoading: isLoadingShort}] = useLazyGetShortLinksExportQuery()

  const donwloadData = () => {
    getApiExport(params)
      .unwrap()
      .then((res) => {
        window.open(`${API_DOMAIN}${res.data.downloadurl}`, '_self')
      })
  }

  const handleExport = (id: string) => {
    setExportedId(id)
    fetchExport(id).then((res: any) => {
      if (res.data) {
        toast.success(res.data?.message)
        window.open(`${API_DOMAIN}${res?.data?.data?.downloadurl}`, '_self')
      } else if (res.error) {
        toast.error(res.error)
        console.error('Error Fetch Message:', res.error)
      }
    }).catch((err) => {
      toast.error(err.error)
    }).finally(() => {
      setExportedId('')
    })
  }

  useEffect(() => {
      fetch(params)
  }, [])

  useEffect(() => {
    if (triggerFetch && triggerFetch === true) {
      doFetch(params)
    }
    setTriggerFetch(false)
  }, [triggerFetch])

  useEffect(() => {
    if (data) {
      const loadedData = calculate(
        data && data.data.current ? data.data.current : 1,
        params.limit,
        data && data.data.total ? data.data.total : 0
      )
      setLoadedData(loadedData)
    }
  }, [isLoading, isFetching])

  const doFetch = useCallback(
    (params) => {
      fetch(params)
        .then((res) => {
          if ('data' in res) {
            toast.success(res.data?.message)
          } else if ('error' in res) {
            toast.error(res.error)
            console.error('Error Fetch Message:', res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [fetch]
  )

  const isNotExpired = (date?: Date) => {
    // return moment(date).isAfter(moment(userTimezoneNow))
    return true
  };

  return (
    <div className='mt-8'>
      <ShortUrlModal
        inputRef={inputRef}
        isShow={popup}
        initialData={webLinkDataToEdit}
        onClose={() => {
          setPopup(false)
          setTriggerFetch(true)
        }}
        bulkMessageData={null}
        setBulkMessageData={() => { }}
      />
      <div className='card p-8'>
        <div className='card-header border-0 p-0 align-items-center mb-5' style={{ zIndex: 20 }}>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <div>
                <span className='fw-bolder fs-3 mb-1'>All Short Links</span>
                <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id="tooltip-bottom">
                    <span>Short links (also called short URLs) are compressed versions of long web addresses, making them shorter, cleaner, and easier to share.</span>
                  </Tooltip>}
                >
                  <i
                    className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
                  />
                </OverlayTrigger>
              </div>
            </h3>
            <div className='d-flex gap-4 align-items-center justify-content-between mt-5  flex-column flex-sm-row overflow-hidden'>
              <div className='d-flex flex-column flex-sm-row'>
                <div className='d-flex border-1 h-46px'>
                  <KTSVG
                    path='/media/icons/duotune/general/gen021.svg'
                    className='svg-icon-1 position-absolute ms-6 mt-3'
                  />
                  <input
                    type='text'
                    value={params.shortUrl ? params.shortUrl : ''}
                    data-kt-user-table-filter='search'
                    className='rounded-start form-control form-control-solid max-w-300px ps-14'
                    style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, height: '46px' }}
                    placeholder='Search Link'
                    onChange={(e: any) => setParams({ ...params, shortUrl: e.target.value, page: 1 })}
                    onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
                      if (event.key === 'Enter') {
                        event.preventDefault()
                        setTriggerFetch(true)
                      }
                    }}
                  />
                </div>
                <button
                  className='rounded-end btn btn-light-primary mt-4 mt-sm-0 ms-0 me-3'
                  style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                  onClick={() => setTriggerFetch(true)}
                >
                  Search
                </button>
              </div>
              <div className='d-flex gap-4'>
                <Link
                  to='/accounts/settings'
                  target='_blank'
                  className='btn'
                  style={{
                    border: '1px solid #7239EA',
                    color: '#7239EA',
                    backgroundColor: 'white',
                  }}
                >
                  Add Custom Domain
                </Link>
                <button className='btn btn-primary' onClick={() => setPopup(true)}>
                  + Create New
                </button>
                <button type='button' onClick={donwloadData} className='btn btn-light-primary'>
                  {isLoadingShort ? (
                    <Spinner size='sm' />
                  ) : (
                    <>
                      <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                      Export
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data.items && data.data.items.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle sticky-header gs-0 gy-5 all-message-table table-row-gray-300'>
                    <thead>
                      <tr className='fw-600 text-muted fs-5'>
                        <th className='min-w-150px min-h-64px ps-2'>Short Link</th>
                        <th className='min-w-100px min-h-100px'>Destination Link</th>
                        <th className='min-w-140px min-h-64px'>Link Status</th>
                        <th className='min-w-100px min-h-64px'>Created Date</th>
                        <th className='min-w-100px min-h-64px'>Total Clicks</th>
                        <th className='min-w-100px min-h-64px text-center'>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={5} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items?.map((item, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-1 border-bottom'>
                                <td className='text-truncate'>{item.shortUrl || '-'}</td>
                                <td className='text-truncate text-wrap'>{item.upstreamUrl || '-'}</td>
                                <td className='text-truncate'>
                                  <span
                                    style={{
                                      display: 'inline-block',
                                      padding: '0.5em 0.85em',
                                      fontSize: '85%',
                                      fontWeight: '600',
                                      lineHeight: '1',
                                      textAlign: 'center',
                                      whiteSpace: 'nowrap',
                                      verticalAlign: 'baseline',
                                      borderRadius: '0.475rem',
                                      backgroundColor:
                                        isNotExpired(item.expireAt)
                                          ? '#E9F2FF'
                                          : '#F1F2F4',
                                      color:
                                        isNotExpired(item.expireAt)
                                          ? '#0C66E4'
                                          : '#44546F',
                                    }}
                                  >
                                    {isNotExpired(item.expireAt) ? 'Active' : 'Expired'}
                                  </span>
                                </td>
                                <td className='text-truncate'>
                                  {item.createdAt
                                    ? moment(item.createdAt).format('DD MMMM YYYY')
                                    : '-'}
                                </td>
                                <td className='text-truncate'>{item.click}</td>
                                <td className='d-flex gap-2 justify-content-end'>
                                  <OverlayTrigger
                                    placement='top'
                                    overlay={<Tooltip id="tooltip-top">
                                      <span>Copy ID</span>
                                    </Tooltip>}
                                  >
                                    <Button
                                      variant='light'
                                      className='btn btn-sm btn-icon'
                                      onClick={() => {
                                        navigator.clipboard.writeText(item?._id)
                                        toast.success('Successfully copied short link id')
                                      }}
                                    >
                                      <i className='bi bi-clipboard'></i>
                                    </Button>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    placement='top'
                                    overlay={<Tooltip id="tooltip-top">
                                      <span>Export</span>
                                    </Tooltip>}
                                  >
                                    <Button variant='light' className='btn btn-sm btn-icon' onClick={() => handleExport(item._id)} disabled={isLoadingExport}>
                                      {isLoadingExport && exportedId === item._id ? <Spinner /> : <i className='bi bi-download'></i>}
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
                <div className='abcd'>
                  <div className='d-flex gap-sm-1 align-items-center text-muted'>
                    <div>Show data</div>
                    <select
                      onChange={(e: any) => {
                        setParams({ ...params, limit: e.target.value })
                        setTriggerFetch(true)
                      }}
                      value={params.limit || 10}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                    <div>per page</div>
                  </div>
                  <div>
                    {isFetching
                      ? '. . . . .'
                      : `Show ${loadedData.startLoad} - ${loadedData.endLoad} of ${data.data.total ? data.data.total : 0
                      } Links`}
                  </div>
                  <ReactPaginate
                    previousLabel='< Prev'
                    nextLabel='Next >'
                    previousClassName={'pagination_prev_next'}
                    nextClassName={'pagination_prev_next'}
                    pageCount={data?.data?.totalPages}
                    marginPagesDisplayed={0}
                    onPageChange={(e: any) => {
                      setParams({ ...params, page: e.selected + 1 })
                      setTriggerFetch(true)
                    }}
                    breakLabel='...'
                    pageRangeDisplayed={3}
                    containerClassName={'pagination'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            ) : (
              <NodataYet message='No Short Link (yet!)' />
            )}
          </>
        )}
      </div>
    </div>
  )
}

const AnalyticCountGroup: FC = () => {
  const [fetchData, { isLoading, data, isFetching }] = useLazyAnalyticShortLinkCountByCountryQuery()
  const [fetchDataCity, { isLoading: isLoadingCity, data: dataCity, isFetching: isFetchingCity }] =
    useLazyAnalyticShortLinkCountByCityQuery()
  const [selectedTab, setSelectedTab] = useState('countries')
  const today = new Date() // Current date

  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([today, new Date()])
  const [startDate, endDate] = dateRange

  const setDateParams = (dateRangeParams: [Date | null, Date | null]) => {
    let [startDate, endDate] = dateRangeParams

    if (endDate === null) {
      endDate = new Date()
    }
    setDateRange(dateRangeParams)
  }

  const mapData: MapData<{ id: string }> = {
    areas: data?.data.map((item) => ({ id: item._id })) || [],
  }

  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);

  const totalItems = data?.data?.length || 0;
  const pageCount = Math.ceil(totalItems / itemsPerPage);

  const offset = Math.min(currentPage * itemsPerPage, totalItems);
  const currentItems = data?.data?.slice(offset, offset + itemsPerPage) || [];

  const handlePageChange = (selected: any) => {
    setCurrentPage(selected.selected);
  };

  const handleItemsPerPageChange = (event: any) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(0);
  };

  const handleSelectedShortLinkType = (type: string) => {
    setSelectedTab(type);
    setCurrentPage(0);
    fetchData(null);
  };

  useEffect(() => {
    if (selectedTab) {
      handlePageChange({ selected: 0 });
    }
    fetchData(null);
  }, [fetchData, selectedTab])

  return (
    <div className='mt-8'>
      <div className='card p-6'>
        <div className='card-header border-0 p-0 align-items-center mb-10 min-h-auto'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>Click by Country & Cities</span>
            </h3>
          </div>
        </div>
        {isLoading ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            <Row id='section-click-report'>
              <Col xs={12} sm={6} md={6}>
                <div className='d-flex flex-column mt-3 mb-9'>
                  <Col
                    xs={12}
                    sm={6}
                    md={6}
                    className='d-flex align-items-center bg-transparent border border-2 rounded-2 mb-9 px-6'
                  >
                    <DatePicker
                      selectsRange={true}
                      dateFormat='MMM d, yyyy'
                      className=' border-0 form-control form-control-lg form-control-solid bg-transparent py-0'
                      placeholderText='Pick data & time'
                      onChange={(update) => {
                        setDateParams(update)
                      }}
                      startDate={startDate}
                      endDate={endDate}
                      disabled={false}
                    />
                    <KTSVG path='/media/svg/calendar.svg' className='svg-icon-2 me-4' />
                  </Col>
                  <div>
                    <GeoMaps data={mapData} />
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={6} md={6}>
                <div className='d-flex justify-content-between align-items-center mt-3 mb-9 px-8'>
                  <div className='border border-2 rounded-2 p-1'>
                    <ButtonGroup>
                      <ToggleButton
                        id='countries-toggle'
                        type='radio'
                        name='toggle'
                        value='countries'
                        variant='light'
                        checked={selectedTab === 'countries'}
                        onClick={() => handleSelectedShortLinkType('countries')}
                        className={`toggle-btn ${selectedTab === 'countries' ? 'active' : ''}`}
                      >
                        COUNTRIES
                      </ToggleButton>
                      <ToggleButton
                        id='cities-toggle'
                        type='radio'
                        name='toggle'
                        value='cities'
                        variant='light'
                        checked={selectedTab === 'cities'}
                        onClick={() => handleSelectedShortLinkType('cities')}
                        className={`toggle-btn ${selectedTab === 'cities' ? 'active' : ''}`}
                      >
                        CITIES
                      </ToggleButton>
                    </ButtonGroup>
                  </div>
                </div>
                {data && data.data?.length > 0 ? (
                  <div className='card-body p-0 pt-1'>
                    <div className='table-responsive'>
                      <table className='table table-row-gray-300 align-middle gs-0 gy-5 all-message-table'>
                        <thead>
                          <tr className='fw-400 text-muted bg-light'>
                            <th className='p-0 min-w-50px w-30px p-4 text-center'>#</th>
                            <th className='p-0 min-w-50px w-100 p-4 text-left'>
                              {selectedTab === 'countries' ? 'Country' : 'City'}
                            </th>
                            <th className='p-0 min-w-100px p-4 text-center'>Clicks</th>
                            <th className='p-0 min-w-100px p-4 text-center'>%</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <tr>
                              <td colSpan={7} className='text-center'>
                                <Spinner />
                              </td>
                            </tr>
                          ) : (
                            <>
                              {currentItems.map((key, i: number) => (
                                <React.Fragment key={i}>
                                  <tr className='border-dashed border-2 border-bottom'>
                                    <td className='top-align text-center'>{offset + i + 1}</td>
                                    <td className='top-align'>{key?.name}</td>
                                    <td className='top-align text-center'>{key?.total || '-'}</td>
                                    <td className='top-align text-center'>{`${key?.total}%`}</td>
                                  </tr>
                                </React.Fragment>
                              ))}
                            </>
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="abcd">
                      <select onChange={handleItemsPerPageChange} value={itemsPerPage}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                      </select>

                      <p>
                        {totalItems > 0
                          ? `Showing ${offset + 1} to ${Math.min(offset + itemsPerPage, data?.data?.length)} of ${data?.data?.length} countries`
                          : "Loading..."}
                      </p>

                      {data?.data?.length > 0 && (
                        <ReactPaginate
                          previousLabel="<"
                          nextLabel=">"
                          pageCount={pageCount}
                          onPageChange={handlePageChange}
                          forcePage={currentPage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"pagination__link"}
                          nextLinkClassName={"pagination__link"}
                          disabledClassName={"pagination__link--disabled"}
                          activeClassName={"pagination__link--active"}
                        />
                      )}
                    </div>
                  </div>
                ) : (
                  <NodataYet message='No recent api messages (yet!)' />
                )}
              </Col>
            </Row>
          </>
        )}
      </div>
    </div>
  )
}

export default ShortLinkPage
